import ThemeSettings from '../commun/ThemeSettings';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import swal from "sweetalert";
import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { DeletePreBookingRoom, Editbookings, PropeortyBookingConfirm, roomlistdetail, SavePreBookingRoomAdd } from '../../Services/Service';

export const EditBooking = () => {

  const location = useLocation();
  const bookingID = location.state?.bookingID;
  const [loading, setLoading] = useState(false);
  const [masterDetails, setMasterDetails] = useState(null);
  const [roomDetails, setRoomDetails] = useState([]);
  const [guestDetails, setGuestDetails] = useState(null);
  const [companyDetails, setCompanyDetails] = useState(null);
  const [bookingComment, setBookingComment] = useState("");
  const [paymentComment, setPaymentComment] = useState("");
  const [rateCode, setRateCode] = useState("");
  const [rooms, setRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [mealPlans, setMealPlans] = useState([]);
  const [, setTaxDetails] = useState([]);
  const [selectedMealPlan, setSelectedMealPlan] = useState(null);
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [extraBed, setExtraBed] = useState(0);
  // const [roomRate, setRoomRate] = useState("");
  const [, setShowModal] = useState(false);


  useEffect(() => {
    if (!bookingID) return;

    const FetchEditbookingDetail = async () => {
      setLoading(true);
      try {
        const result = await Editbookings(bookingID);
        // console.log("result", result);
        if (result) {

          const preBookingID = result?.MasterDetails?.[0]?.PreBookingID;
          if (preBookingID) {
            localStorage.setItem("PreBookingID", preBookingID);
          }

          setMasterDetails(result.MasterDetails[0]);
          setRoomDetails(result.RoomDetails);
          setTaxDetails(result.TaxDetails);
          setGuestDetails(result.GuestDetails[0]);
          setCompanyDetails(result.CompanyDetails[0]);
          setBookingComment(result.BookingCommentDetails[0]?.BookingComment || "");
          setPaymentComment(result.PaymentCommentDetails?.[0]?.PaymentComment || "");
          setRateCode(result.BookingDetails?.[0]?.RateCode || "");
        }
      } catch (error) {
        console.log("error fetch booking detail", error);
      } finally {
        setLoading(false);
      }
    };

    FetchEditbookingDetail();
  }, [bookingID]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // token (PreBookingID) ko localStorage me store karke rakha tha
      // const preBookingToken = localStorage.getItem("PreBookingToken");
      const preBookingToken = localStorage.getItem("PreBookingID");

      if (!preBookingToken) {
        alert("PreBookingToken missing in localStorage!");
        return;
      }

      const payload = {
        PreBookingToken: preBookingToken,
        TotalRoomRate: masterDetails?.TotalRoomRate || 0,
        TotalExtraBedCharges: masterDetails?.TotalExtraBedCharges || 0,
        TotalPayment: masterDetails?.TotalPayment || 0,
        Tax: masterDetails?.Tax || 0,
        TotalAfterTax: masterDetails?.TotalAfterTax || 0,
        Discount: masterDetails?.Discount || 0,
        PaymentComment: paymentComment,
        CompanyName: companyDetails?.CompanyName || "",
        RegistrationNumber: companyDetails?.RegistrationNumber || "",
        RegistrationCompanyName: companyDetails?.RegistrationCompanyName || "",
        RegistrationCompanyAddress: companyDetails?.RegistrationCompanyAddress || "",
        MarketSegment: companyDetails?.MarketSegment || "",
        BookingComment: bookingComment,
        Title: guestDetails?.Title || "",
        FirstName: guestDetails?.FirstName || "",
        MiddleName: guestDetails?.MiddleName || "",
        LastName: guestDetails?.LastName || "",
        EmailAddress: guestDetails?.EMailAddress || "",
        Address: guestDetails?.Address || "",
        MobileNumber: guestDetails?.MobileNumber || "",
        Country: guestDetails?.Country || "",
        State: guestDetails?.State || "",
        City: guestDetails?.City || "",
      };

      console.log("Payload sending =>", payload);

      const res = await PropeortyBookingConfirm(payload);

      if (res?.PreBookingToken) {
        // localStorage.setItem("PreBookingToken", res.PreBookingToken);
        alert("Booking updated successfully ✅");
      } else {
        alert("Failed to update booking ❌");
      }

    } catch (err) {
      console.error("Error submitting booking:", err);
      alert("Error while saving booking ❌");
    } finally {
      setLoading(false);
    }
  };


  // add room api 

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const result = await roomlistdetail();
        if (result && Array.isArray(result)) {
          setRooms(result);
        }
      } catch (err) {
        console.error("Error fetching rooms:", err);
      }
    };
    fetchRooms();
  }, []);

  // jab room change hoga → uske meal plans nikalenge
  const handleRoomChange = (e) => {
    const roomId = e.target.value;
    const room = rooms.find((r) => r.RoomID.toString() === roomId);
    setSelectedRoom(room);

    if (room?.RatePlanDetails) {
      try {
        const parsedPlans = JSON.parse(room.RatePlanDetails);
        setMealPlans(parsedPlans);
      } catch (err) {
        console.error("Error parsing RatePlanDetails:", err);
        setMealPlans([]);
      }
    } else {
      setMealPlans([]);
    }
  };

  const handleAddRoomSave = async () => {
    if (!selectedRoom) {
      swal("Please select a room type!", {
        icon: "warning",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-warning",
          },
        },
      });
      return;
    }

    const preBookingToken = localStorage.getItem("PreBookingID");

    const formData = new FormData();
    formData.append("ID", "0");
    formData.append("PreBookingToken", preBookingToken);
    formData.append("RoomID", selectedRoom.RoomID);
    formData.append("RatePlanID", selectedMealPlan?.RatePlanID || 0);
    formData.append("TotalRoom", "1");
    formData.append("RoomRate", selectedMealPlan?.RoomRate || 2000);
    formData.append("ExtraBed", extraBed);
    formData.append("ExtraBedAmount", selectedMealPlan?.ExtraBedCharges || 1500);
    formData.append("Adults", adults);
    formData.append("Child", children);

    try {
      setLoading(true);
      const result = await SavePreBookingRoomAdd(formData);
      console.log("Room added successfully", result);

      swal("Room added successfully!", {
        icon: "success",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-success",
          },
        },
      }).then(() => {
        setShowModal(false);
        window.location.reload();
      });

    } catch (error) {
      console.error("Error adding room", error);
    } finally {
      setLoading(false);
    }
  };


  const handleDeleteRoom = async (roomId) => {
    const preBookingToken = localStorage.getItem("PreBookingID");
    if (!preBookingToken) {
      alert("PreBookingToken missing!");
      return;
    }

    if (!window.confirm("Are you sure you want to delete this room?")) return;

    try {
      const res = await DeletePreBookingRoom(roomId, preBookingToken);
      if (res) {
        alert("Room deleted successfully ✅");
        // update UI (remove room from state)
        setRoomDetails((prev) => prev.filter((r) => r.ID !== roomId));
      } else {
        alert("Failed to delete room ❌");
      }
    } catch (err) {
      console.error("Error deleting room:", err);
      alert("Error while deleting ❌");
    }
  };



  if (!masterDetails) {
    return <div>Loading booking details...</div>;
  }

  return (
    <>
      <style> {`
        th {
          background-color:#a2a7b7 !important;
          color: #fff !important;
        }
      `}
      </style>

      {loading && (
        <div className="fullscreen-loader">
          <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
        </div>
      )}

      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />
          <div className="container">
            <div className="page-inner">
              <div className="row">
                <div className="col-md-12">
                  <div className="card mb-0 ">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Property Edit Room Details</h4>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">Arrival:</label>
                              <input type="date" className="form-control" value={masterDetails.CheckInDate ? masterDetails.CheckInDate.split("T")[0] : ""}
                                onChange={(e) =>
                                  setMasterDetails((prev) => ({
                                    ...prev,
                                    CheckInDate: e.target.value,
                                  }))
                                } />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">
                                Departure:
                              </label>
                              <input type="date" className="form-control" value={masterDetails.CheckOutDate ? masterDetails.CheckOutDate.split("T")[0] : ""}
                                onChange={(e) =>
                                  setMasterDetails((prev) => ({
                                    ...prev,
                                    CheckOutDate: e.target.value,
                                  }))
                                } />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">
                                Rate Code:
                              </label>
                              <select className="form-control form-select" value={rateCode}
                                onChange={(e) => setRateCode(e.target.value)}>
                                <option value="">select type</option>
                                <option value="Property">Property</option>
                                <option value="TravelAgent">Travel Agent</option>
                                <option value="Corporate">Corporate</option>
                              </select>
                            </div>
                          </div>



                          {/*hotel rooom table */}

                          <div className="col-md-12">
                            <div className="table-responsive">
                              <div className='text-end'>
                                <button type="button" className="btn btn-sm btn-primary mb-2 " data-bs-toggle="modal" data-bs-target="#con-close-modal"> <i className='fas fa-plus'></i> ADD </button>
                              </div>
                              <table
                                className="display table table-striped table-bordered table-hover"

                              >
                                <thead>
                                  <tr >
                                    <th className='th'> Room Type </th>
                                    <th> Plan </th>
                                    {/* <th>  Rooms </th> */}
                                    <th> Adult</th>
                                    <th>Child</th>
                                    <th> Extra Bed's</th>
                                    <th> Amount </th>
                                    <th> Action </th>
                                  </tr>
                                </thead>

                                <tbody>

                                  {roomDetails.map((room) => (
                                    <tr key={room.ID}>
                                      <td>{room.RoomName}</td>
                                      <td>{room.RatePlan}</td>
                                      <td>{room.Adults}</td>
                                      <td>{room.Child}</td>
                                      <td>{room.ExtraBed}</td>
                                      <td>₹ {room.ExtraBedAmount}</td>


                                      <td className='text-center'>
                                        <button type='button' className=' btn py-0 px-1' style={{ color: "red" }} onClick={() => handleDeleteRoom(room.ID)}><i className='fas fa-trash'></i></button>

                                      </td>
                                    </tr>
                                  ))}

                                </tbody>
                              </table>
                            </div>
                          </div>


                          <div className="m-1 mt-4">
                            <div className="border bg-gray1 rounded-2 position-relative">
                              <h6
                                className="fw-bold position-absolute"
                                style={{
                                  top: "-12px",
                                  paddingInline: "8px",
                                  backgroundColor: "#f5f7fd ",
                                  left: "5px",
                                }}
                              >
                                Total Amount{" "}
                              </h6>
                              <div className="row align-items-end p-3">
                                <div className="col-auto">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Amount
                                    </label>
                                    <input type="number" className="form-control" value={masterDetails?.TotalRoomRate || 0} readOnly />
                                  </div>
                                </div>

                                <div className="col-auto d-flex align-items-end pb-1">
                                  <span className="fw-bold fs-3">+</span>
                                </div>

                                <div className="col-auto">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Tax (%)
                                    </label>
                                    <input type="number" className="form-control" value={masterDetails?.Tax || 0} readOnly />
                                  </div>
                                </div>

                                <div className="col-auto d-flex align-items-end pb-1">
                                  <span className="fw-bold fs-3">=</span>
                                </div>

                                <div className="col-auto">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Total Amount After Tax
                                    </label>
                                    <input type="text" className="form-control" value={masterDetails?.TotalAfterTax || 0} readOnly />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>


                          {/* guest details table */}

                          <div className="col-md-12">
                            <h4 className="mt-3">Guest Details:</h4>
                            <div className="table-responsive">
                              <table
                                className="display table table-striped table-bordered table-hover"
                                style={{
                                  width: "100%",
                                  tableLayout: "auto",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th>Title</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Contact No </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <select className='form-select form-control' value={guestDetails?.Title || ""}
                                        onChange={(e) =>
                                          setGuestDetails((prev) => ({ ...prev, Title: e.target.value }))
                                        }>
                                        <option>Select</option>
                                        <option>Mr.</option>
                                        <option>Mrs.</option>
                                        <option>Ms.</option>
                                        <option>Dr.</option>
                                      </select>
                                    </td>
                                    <td>
                                      <input type="text" className="form-control" placeholder="Enter First Name" value={guestDetails?.FirstName || ""}
                                        onChange={(e) =>
                                          setGuestDetails((prev) => ({ ...prev, FirstName: e.target.value }))
                                        } />
                                    </td>
                                    <td>
                                      <input type="text" className="form-control" placeholder="Enter Last Name" value={guestDetails?.LastName || ""}
                                        onChange={(e) =>
                                          setGuestDetails((prev) => ({ ...prev, LastName: e.target.value }))
                                        } />
                                    </td>
                                    <td>
                                      <input type="number" className="form-control" placeholder="Enter Contact No" value={guestDetails?.MobileNumber || ""}
                                        onChange={(e) =>
                                          setGuestDetails((prev) => ({ ...prev, MobileNumber: e.target.value }))
                                        } />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                            </div>
                          </div>




                          <div className="col-md-4">
                            <div className="input-block ">
                              <label className="col-form-label">Email:</label>
                              <input type="email" className="form-control" placeholder="Enter Email" value={guestDetails?.EMailAddress || ""}
                                onChange={(e) =>
                                  setGuestDetails((prev) => ({ ...prev, EMailAddress: e.target.value }))
                                } />
                              <div className="form-check d-flex">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                <label className="form-check-label" htmlFor="flexCheckDefault"  >
                                  Do want to receive Booking Voucher on email ?
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block">
                              <label className="col-form-label">Address</label>
                              <textarea
                                type="text"
                                className="form-control"
                                placeholder="Enter Address"
                                value={guestDetails?.Address || ""}
                                onChange={(e) =>
                                  setGuestDetails((prev) => ({ ...prev, Address: e.target.value }))
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-2 ">
                            <div className="input-block">
                              <label className="col-form-label">City</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter City"
                                value={guestDetails?.City || ""}
                                onChange={(e) =>
                                  setGuestDetails((prev) => ({ ...prev, City: e.target.value }))
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">Country</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Country"
                                value={guestDetails?.Country || ""}
                                onChange={(e) =>
                                  setGuestDetails((prev) => ({ ...prev, Country: e.target.value }))
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">State</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter State"
                                value={guestDetails?.State || ""}
                                onChange={(e) =>
                                  setGuestDetails((prev) => ({ ...prev, State: e.target.value }))
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">
                                Company Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Company Name"
                                value={companyDetails?.CompanyName || ""}
                                onChange={(e) =>
                                  setCompanyDetails((prev) => ({ ...prev, CompanyName: e.target.value }))
                                }
                              />
                            </div>
                          </div>

                          <div className="m-1 mt-4">
                            <div className="border bg-gray1 rounded-2 position-relative">
                              <h6
                                className=" fw-bold position-absolute bg-gray1"
                                style={{
                                  top: "-12px",
                                  left: "12px",
                                  paddingInline: "4px",
                                }}
                              >
                                Enter GST Details (Optional)
                              </h6>
                              <div className="row p-3">
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registration Number
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Registration Number"
                                      value={companyDetails?.RegistrationNumber || ""}
                                      onChange={(e) =>
                                        setCompanyDetails((prev) => ({ ...prev, RegistrationNumber: e.target.value }))
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registered Company name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Registred Company Name"
                                      value={companyDetails?.RegistrationCompanyName || ""}
                                      onChange={(e) =>
                                        setCompanyDetails((prev) => ({
                                          ...prev,
                                          RegistrationCompanyName: e.target.value,
                                        }))
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registered Company address
                                    </label>
                                    <textarea
                                      type="text"
                                      className="form-control"
                                      placeholder="Registered Company Address"
                                      value={companyDetails?.RegistrationCompanyAddress || ""}
                                      onChange={(e) =>
                                        setCompanyDetails((prev) => ({
                                          ...prev,
                                          RegistrationCompanyAddress: e.target.value,
                                        }))
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                Billing Instructions:
                              </label>
                              <select className="form-select form-control" >
                                <option>Select Billing Instruction</option>
                                <option value="Pay at hotel">Pay at hotel</option>
                                <option value="Prepaid">Prepaid</option>
                                <option value="Send Invoice">Send Invoice</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label
                                className="col-form-label"
                                htmlFor="exampleInputEmail1"
                              >
                                Market Segment
                              </label>
                              <select
                                className="form-select form-control"
                                value={companyDetails?.MarketSegment || ""}
                                onChange={(e) =>
                                  setCompanyDetails((prev) => ({
                                    ...prev,
                                    MarketSegment: e.target.value,
                                  }))
                                }
                              >
                                <option>Select</option>
                                <option value="ADH">Adhoc</option>
                                <option value="AIR">Airline/ Crew</option>
                                <option value="BAR">Rate htmlFor the day </option>
                                <option value="CMP">Complimentary</option>
                                <option value="CNC">Corporate Non Contracted </option>
                                <option value="CNF">Conference</option>
                                <option value="COR"> Corporate Negotiated Rate </option>
                                <option value="CRT">Consortia</option>
                                <option value="DAY">Day Use</option>
                                <option value="GOV">Government</option>
                                <option value="HSU">House Use</option>
                                <option value="LNG">Long Stay</option>
                                <option value="LYT">Loyalty</option>
                                <option value="OTA">Online Travel Agent</option>
                                <option value="OWN">Owners</option>
                                <option value="PHR">Pharma Group</option>
                                <option value="PKG">Package</option>
                                <option value="PSU">Public Sector Unit</option>
                                <option value="PUB">Rack/ Publish tariff</option>
                                <option value="RED">Redemption</option>
                                <option value="RFP">Corporate RFP</option>
                                <option value="TRA">Travel Agent</option>
                                <option value="WDD">Wedding</option>
                                <option value="WEB">Brand Web Site</option>
                                <option value="A">Contract</option>
                                <option value="B">TR - Promotions Global</option>
                                <option value="CMP">Complimentary Rooms</option>
                                <option value="D">TR - Member Discounts</option>
                                <option value="E">TR - Negotiated Global</option>
                                <option value="G">TR - Government</option>
                                <option value="GAS">GR - ASSOCIATION</option>
                                <option value="GCP">GR - CORPORATE</option>
                                <option value="GCW">GR - CITYWIDE</option>
                                <option value="GGV">GR - GOVERNMENT</option>
                                <option value="GIC">GR - SMERF</option>
                                <option value="GSF">GR - SMERF</option>
                                <option value="GTT">GR - TOUR & TRAVEL</option>
                                <option value="H">TR - Promotions Local</option>
                                <option value="HSE">House Use</option>
                                <option value="L">TR - Negotiated Local</option>
                                <option value="M">TR - Loyalty</option>
                                <option value="O">TR - OTA Opaque</option>
                                <option value="P">TR - OTA Promotions</option>
                                <option value="Q">TR - OTA Retail</option>
                                <option value="R">TR - Retail</option>
                                <option value="T">TR - TMC</option>
                                <option value="X">TR - Wholesale Discounts</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                Bus Source:
                              </label>
                              <select className="form-select form-control" >
                                <option>Select</option>
                                <option value="Online">Online</option>
                                <option value="Offline">Offline</option>
                                <option value="Corporate">Corporate</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="ïnput-block mb-3">
                              <label className="col-from-lable">
                                Booking Comment
                              </label>
                              <textarea
                                className="form-control"
                                placeholder="Special Requriment"
                                value={bookingComment}
                                onChange={(e) => setBookingComment(e.target.value)}
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="ïnput-block mb-3">
                              <label className="col-from-lable">
                                Payment Comment
                              </label>
                              <textarea
                                className="form-control"
                                placeholder="Payment Comment"
                                value={paymentComment}
                                onChange={(e) => setPaymentComment(e.target.value)}
                              ></textarea>
                            </div>
                          </div>

                          {/* <!-- Submit Button --> */}
                          <div className="card-action text-end">
                            <button type="submit" className="btn btn-black">
                              Update
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <>
              <div
                id="con-close-modal"
                className="modal fade"
                tabIndex={-1}
                role="dialog"
                aria-hidden="true"
                style={{ display: "none" }}
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title">Add Room</h4>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body p-4">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              ROOM TYPE
                            </label>
                            <select className="form-control form-select" onChange={handleRoomChange}>
                              <option>select type</option>
                              {rooms.map((room) => (
                                <option key={room.RoomID} value={room.RoomID}>
                                  {room.RoomName}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              MEAL PLAN
                            </label>
                            <select className="form-control form-select" onChange={(e) =>
                              setSelectedMealPlan(
                                mealPlans.find(
                                  (plan) => plan.RatePlanID.toString() === e.target.value
                                )
                              )
                            }>
                              <option>select Plan</option>
                              {mealPlans.length > 0 ? (
                                mealPlans.map((plan) => (
                                  <option key={plan.RatePlanID} value={plan.RatePlanID}>
                                    {plan.RatePlan}
                                  </option>
                                ))
                              ) : (
                                <option value="0">No Meal Plan</option>
                              )}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">
                              ADULT
                            </label>
                            <select className="form-control form-select" value={adults}
                              onChange={(e) => setAdults(e.target.value)}>
                              <option>0</option>
                              <option>1</option>
                              <option>2</option>
                              <option>3</option>
                              <option>4</option>
                              <option>5</option>
                              <option>6</option>
                              <option>7</option>
                              <option>8</option>
                              <option>9</option>
                              <option>10</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">
                              CHILD
                            </label>
                            <select className="form-control form-select" value={children}
                              onChange={(e) => setChildren(e.target.value)}>
                              <option>0</option>
                              <option>1</option>
                              <option>2</option>
                              <option>3</option>
                              <option>4</option>
                              <option>5</option>
                              <option>6</option>
                              <option>7</option>
                              <option>8</option>
                              <option>9</option>
                              <option>10</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">
                              EXTRA BED
                            </label>
                            <select className="form-control form-select" value={extraBed}
                              onChange={(e) => setExtraBed(e.target.value)}>
                              <option>0</option>
                              <option>1</option>
                              <option>2</option>
                              <option>3</option>
                              <option>4</option>
                              <option>5</option>
                              <option>6</option>
                              <option>7</option>
                              <option>8</option>
                              <option>9</option>
                              <option>10</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-info waves-effect waves-light" onClick={handleAddRoomSave} >
                        Save changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* /.modal */}
            </>
          </div>
          <ThemeSettings />
        </div>
      </div>
    </>
  )
}
